import styled from 'styled-components';

export const Tile = styled.a`
  height: 220px;
  padding: 15px;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.baseBlue.a10};
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease-out;

  &:hover {
    background-color: ${({ theme }) => theme.baseBlue.a3};
  }

  &.finished {
    background-color: #ded;
    &:hover {
      background-color: #aba;
    }
  }
`;

export const TileTitle = styled.h4`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 45px;
  text-align: center;
`;

export const TileAvatar = styled.div`
  height: 50px;
  width: 50px;
  margin: 20px auto;
`;

export const TileTimeleft = styled.div`
  text-align: center;
  font-size: 12px;
  height: 20px;
`;

export const TileStatus = styled.div`
  height: 20px;
  text-align: center;
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const TileName = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
